"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function dcAdminFooterNavController($window, NavigationHistoryService) {
    var vm = this;
    vm.navBack = function () {
        if (NavigationHistoryService.getHistory().length > 1) {
            $window.history.back();
        }
    };
}
dcAdminFooterNavController.$inject = ["$window", "NavigationHistoryService"];
exports.default = dcAdminFooterNavController;
